import React from 'react';

import { Button } from '../../../../../base/components/Button';
import { Icon } from '../../../../../base/components/Icon';

import './styles.scss';

interface Props {
    backLinkText: string;
    nextLinkText: string;
    progressWidth: number;
    hideBackbutton?: boolean;
    hideNextIcon?: boolean;
    onBackClick: () => void;
    onNextClick: () => void;
}

export const Footer = ({
    backLinkText,
    nextLinkText,
    progressWidth,
    hideBackbutton,
    hideNextIcon,
    onBackClick,
    onNextClick,
}: Props) => {
    return (
        <div className='quick-apply-footer'>
            <div className='app-progress-bar'>
                <span className='app-progress-bar__progress' style={{ width: `${progressWidth}%` }}></span>
            </div>
            <div className='quick-apply-footer__buttons-wrap'>
                {!hideBackbutton && (
                    <Button className='quick-apply-footer__button' type='link' onClick={onBackClick}>
                        {backLinkText}
                    </Button>
                )}

                <Button className='quick-apply-footer__button quick-apply-footer__button--next' onClick={onNextClick}>
                    {nextLinkText}
                    {!hideNextIcon && (
                        <Icon
                            className='quick-apply-footer__button-icon'
                            icon='arrow-right-long-solid'
                            color='white'
                            size='15'
                        />
                    )}
                </Button>
            </div>
        </div>
    );
};
